import { memo } from 'react'
import ReactMarkdown from 'react-markdown'

import type { FC } from 'react'
import type { Options } from 'react-markdown'

export const CommonMarkDown: FC<Options> = memo(
  ReactMarkdown,
  (prevProps, nextProps) => prevProps.children === nextProps.children,
)
